import React from 'react';

interface DonateButtonProps {
    canSubmit: boolean;
}

const DonateButton: React.FC<DonateButtonProps> = ({ canSubmit }) => {
    return (
        <div>
            <button
                type="submit"
                disabled={!canSubmit}
                className="relative overflow-hidden text-base w-full px-4 py-3 sm:py-2 border border-transparent rounded-md shadow-sm
                    font-medium text-white bg-[#3371e6] hover:bg-[#2a5fb6] focus:outline-none
                    focus:ring-4 focus:ring-[#a5c8fa] focus:ring-opacity-50 disabled:bg-gray-400
                    disabled:cursor-not-allowed cursor-pointer transition-all ease-in-out duration-300"
            >
                {canSubmit && (
                    <span className="absolute inset-0 bg-gradient-to-r from-transparent via-blue-300/30
                        to-transparent animate-shimmer"/>
                )}
                <span className="relative">Donate</span>
            </button>
        </div>
    );
};

export default DonateButton;
